var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { localizeUrl } from '../../core/helpers/url-helper';
import { connect } from 'react-redux';
var mapStateToProps = function (state) { return ({
    cartItemsCounter: state.cart.cartItems.collection.counter,
    draftItemsCounter: state.cart.draftItems.collection.counter,
}); };
var connector = connect(mapStateToProps, {});
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Navigation.prototype.render = function () {
        return (React.createElement("nav", { className: "c-navigation" },
            React.createElement("ul", { className: "c-navigation__links" },
                React.createElement("li", { className: "c-navigation__link" },
                    React.createElement(Link, { to: localizeUrl('/drafts'), className: "c-navigation-item" },
                        React.createElement("i", { className: "icon-drafts" }),
                        React.createElement("span", null, this.props.t('navigation.drafts.title')),
                        React.createElement("span", { className: "c-navigation-item__counter c-navigation-item__counter--drafts" }, null !== this.props.draftItemsCounter ? this.props.draftItemsCounter : ''))),
                React.createElement("li", { className: "c-navigation__link" },
                    React.createElement(Link, { to: localizeUrl('/cart'), className: "c-navigation-item" },
                        React.createElement("i", { className: "icon-cart" }),
                        React.createElement("span", null, this.props.t('navigation.cart.title')),
                        React.createElement("span", { className: "c-navigation-item__counter" }, null !== this.props.cartItemsCounter ? this.props.cartItemsCounter : ''))),
                React.createElement("li", { className: "c-navigation__link" },
                    React.createElement(Link, { to: localizeUrl('/account/orders'), className: "c-navigation-item" },
                        React.createElement("i", { className: "icon-account" }),
                        React.createElement("span", null, this.props.t('navigation.account.title')))))));
    };
    return Navigation;
}(React.Component));
export default connector(withTranslation()(Navigation));
